
import ArticleInfoBaseTemplate from './ArticleInfoBaseTemplate';
import ArticleInfoTags from '@root/modules/article/components/info/ArticleInfoTags.vue';
import ArticleInfoSocial from '@root/modules/article/components/info/ArticleInfoSocial.vue';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoSocial,
    ArticleInfoTags,
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    commentsNoBrackets() {
      const { commentsNoBrackets } = this.$channelConfig('settings');
      return commentsNoBrackets;
    },
  },
});
